import { useEffect, useState } from 'react';
import icEyeOpen from './../../assets/svg/ic_eye_open.svg';

const InputLabeled = ({...props}) => {
    const [open, setOpen] = useState(false);
    const [inputType, setInputType] = useState('password');

    const handleChange = (event) => {
        event.preventDefault();
        props.setValue(event.target.value);
    }

    const toggleEye = () => { setOpen(!open); }

    useEffect(() => {
        setInputType(open ? 'text' : 'password');
    }, [open]);

    return (
        <div className={`input-group ${props.className}`}>
            <input
                type={inputType}
                ref={props.innerRef}
                style={props.style}
                autoFocus={props.autoFocus}
                onFocus={props.onFocus}
                onBlur={props.onBlur}
                value={props.value}
                onChange={handleChange}
                className={`form-control`}
                placeholder={props.hint}
                disabled={props.disabled}/>
            <img src={icEyeOpen} onClick={toggleEye} className={`btn border border-gray`} />
        </div>
    );
}

export default InputLabeled;